import Action from 'actions';
import BaseExecutor from 'services/sports/default/base-executor';
import {MinPlayersValidator} from 'services/validations/validators/min-players-validator';
import {MinTeamsValidator} from 'services/validations/validators/min-teams-validator';
import {MaxLockedPlayersSalaryValidator} from 'services/validations/validators/max-locked-players-salary-validator';
import {MaxExposedPlayersSalaryValidator} from 'services/validations/validators/max-exposed-players-salary-validator';
import {MaxLockedPlayersValidator} from 'services/validations/validators/max-locked-players-validator';
import {MaxExposedPlayersValidator} from 'services/validations/validators/max-exposed-players-validator';
import BaseValidator from 'services/validations/base-validator';

class SingleGameValidatorBuilder extends BaseExecutor {
    constructor(private dependencies = {}) {
        super();
    }
    getInterface() {
        const {
            playersData: {preparedPlayers, players},
            playersLock,
            sportConfig,
        } = Action.getState();

        const playersDividedByPosition = preparedPlayers.groupedBy.position();
        const playersGroupedByExposureMin = preparedPlayers.groupedBy.property('exposureMin');

        const minPlayersValidator = new MinPlayersValidator();
        minPlayersValidator.setDependencies({
            sportConfig,
            playersDividedByPosition,
            playersLock,
        });

        const maxLockedPlayersValidator = new MaxLockedPlayersValidator();
        maxLockedPlayersValidator.setDependencies({
            sportConfig,
            playersLock,
        });

        const minTeamsValidator = new MinTeamsValidator();
        minTeamsValidator.setDependencies({
            sportConfig,
            playersDividedByPosition,
        });

        const maxLockedPlayersSalaryValidator = new MaxLockedPlayersSalaryValidator();
        maxLockedPlayersSalaryValidator.setDependencies({
            sportConfig,
            players,
            playersLock,
        });

        const maxExposedPlayersSalaryValidator = new MaxExposedPlayersSalaryValidator();
        maxExposedPlayersSalaryValidator.setDependencies({
            sportConfig,
            playersGroupedByExposureMin,
        });

        // @ts-ignore
        const {exposureMinPropNames = []} = this.dependencies;
        const maxExposedPlayersValidator = new MaxExposedPlayersValidator();
        maxExposedPlayersValidator.setDependencies({
            exposureMinPropNames,
            players,
        });

        const validator = new BaseValidator();
        validator.addSubValidators([
            minPlayersValidator,
            maxLockedPlayersValidator,
            minTeamsValidator,
            maxLockedPlayersSalaryValidator,
            maxExposedPlayersSalaryValidator,
            maxExposedPlayersValidator,
        ]);

        return validator;
    }
}

export {SingleGameValidatorBuilder};
